import React, { useEffect, useState } from "react";
import { calculateScoring } from "../../services/scoringService";
import { Table } from "react-bootstrap";

const ScoringTable = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    calculateScoring().then(res => {
      if (res.success) setData(res.data.perDesa);
    });
  }, []);

  return (
    <div className="p-3">
      <h3>Skor Rumah Tidak Layak Huni per Desa</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Kecamatan</th>
            <th>Desa</th>
            <th>Jumlah Rumah</th>
            <th>Skor Rata-rata</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i}>
              <td>{row.kecamatan}</td>
              <td>{row.desa}</td>
              <td>{row.rumah}</td>
              <td>{row.avgScore}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ScoringTable;
